import { BorderRadiusStyle, BorderWidthStyle } from '../modules/storefront/exports/Constants';
import { BorderRadius, BorderWidth } from '../modules/storefront/exports/Enums';

export const LightBrand = {
  primary: '#69CE8C',
  border: '#DEDEDE',
  background: {
    primary: '#FFFFFF',
    secondary: '#FFFFFF',
    hover: '#F6F6F6',
  },
  card: '#FFFFFF',
  icon: {
    color: '#707070',
    background: '#FFFFFF',
  },
  text: {
    primary: '#161616',
    secondary: '#707070',
  },
  disabled: {
    text: '#FFFFFF',
    background: '#DEDEDE',
  },
};

export const DarkBrand = {
  primary: '#FFFFFF',
  border: '#E5E7EB',
  background: {
    primary: '#121212',
    secondary: '#191919',
    hover: '#2A2A2A',
  },
  card: '#1E1E1E',
  icon: {
    color: '#FFFFFF',
    background: '#1E1E1E',
  },
  text: {
    primary: '#E0E0E0',
    secondary: '#B0B0B0',
  },
  disabled: {
    text: '#CDCDCD',
    background: '#4A4A4A',
  },
};

const Theme = {
  font: {
    size: {
      DEFAULT: '1rem',
      '2xs': '0.625rem',
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1.125rem',
      lg: '1.5rem',
      xl: '2rem',
      '2xl': '2.5rem',
    },
    weight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      DEFAULT: '140%',
      md: '1.5rem',
      lg: '2rem',
      xl: '2.5rem',
      '2xl': '3rem',
    },
  },
  color: {
    primary: '#02872f',
    success: '#29a356',
    notice: '#F2C94C',
    warning: '#FFB3C3',
    danger: '#EB5757',

    brand: LightBrand,

    gradients: {
      primary: ['#69CE8C', '#6ED792'],
    },

    black: {
      DEFAULT: '#161616',
      100: '#373737',
      600: '#1A1A1A',
    },
    white: {
      DEFAULT: '#FFFFFF',
      100: '#FBFBFC',
    },
    secondary: '#ededed',
    hero: '#f5f5f5',
    muted: '#e8e8e8',
    foreground: '#171717',
    'muted-foreground': '#666666',
    gray: {
      DEFAULT: '#DEDEDE',
      background: '#F7F7F7',
      100: '#DAE9EF',
      200: '#A7BAC5',
      300: '#5F6974',
      400: '#E0E0E0',
      500: '#F2F2F2',
      550: '#F5F5F5',
      600: '#EBEBEC',
      700: '#707070',
      800: '#EEEEEE',
      900: '#E7E7E7',
      1000: '#C7C7C8',
      1100: '#E9EAEC',
      1200: '#E8F6F5',
      1300: '#F1F5F9',
    },
    blue: {
      DEFAULT: '#2F80ED',
      100: '#197CBD',
      200: '#EFF5FF',
      300: '#1773B0',
    },
    green: {
      DEFAULT: '#DBFAE2',
      100: '#B9DDC2',
      200: '#3E734C',
      300: '#ECF9F1',
      400: '#45C67B',
      500: '#18A24B',
    },
    orange: {
      DEFAULT: '#F2C94C',
    },
    mobile: {
      secondary: '#AAAAAA',
      tertiary: '#5C5C5C',
      notice: '#ECECEC',
    },
  },
  spacing: {
    none: '0px',
    nano: '2px',
    '2xs': '4px',
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '40px',
  },
  border: {
    radius: BorderRadiusStyle[BorderRadius.Small],
    width: BorderWidthStyle[BorderWidth.Small],
  },
  screens: {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
  },
};

export default Theme;
